import React from "react";
import MUIDataTable from "mui-datatables";
import { Button } from "@material-ui/core";
import TagManager from 'react-gtm-module';

export default function TableModal({ setItensBotoesIndividuais, detalhePedidoProtocoloNF, handleDialogModal }) {
    const columns = [
        {
            name: "NM_PROD",
            label: "Nome do Produto",
        },
        {
            name: "QT_ITEM",
            label: "Quantidade produtos",
        },
        {
            name: "VM_TOT_ITEM",
            label: "Valor total (R$)",
        },
        {
            name: "VM_DESC_ITEM",
            label: "Valor do Desconto (R$)",
        },

        {
            name: "NR_PC",
            options: {
                display: false,
                viewColumns: false,
            },
        },
        {
            name: "CD_FIL",
            options: {
                display: false,
                viewColumns: false,
            },
        },
        {
            name: "ID_PROD",
            options: {
                display: false,
                viewColumns: false,
            },
        },
        {
            name: "DT_ENTRG",
            options: {
                display: false,
                viewColumns: false,
            },
        },
        {
            name: "Alterar Opções",
            options: {
                display: true,
                filter: false,
                download: false,
                viewColumns: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const row = tableMeta.rowData;
                    const rowIndex = tableMeta.rowIndex;
                    
                    const params = [
                        {
                            NM_PROD: row[0],
                            NR_PC: row[4],
                            CD_FIL: row[5],
                            ID_PROD: row[6],
                            DT_ENTRG: row[7].split(" ")[0],
                        },
                    ];
                    return (
                        <>
                            <Button
                                onClick={(e) => {
                                    setItensBotoesIndividuais(params, rowIndex);
                                    TagManager.dataLayer({
                                        dataLayer: {
                                            event: 'event',
                                            eventCategory: 'tokstok:fornecedores:gerenciar-pedidos',
                                            eventAction: 'clique:botao',
                                            eventLabel: 'alterar',
                                        }
                                    });
                                }}
                                color="primary"
                                variant="contained"
                            >
                                Alterar
                            </Button>
                        </>
                    );
                },
            },
        },
    ];

    return (
        <div>
            <MUIDataTable
                maxWidth={"md"}
                data={detalhePedidoProtocoloNF}
                columns={columns}
                options={{
                    title: false,
                    print: false,
                    filter: false,
                    download: false,
                    search: false,
                    viewColumns: false,
                    selectableRows: "none",
                    size: "small",
                    responsive: "scrollFullHeight",
                    rowsPerPage: 4,
                    rowsPerPageOptions: false,
                }}
            />
        </div>
    );
}
